const clientValidateUserIDMapper = (response) => {
    if (response) {
        return {
            accountTypesArray: response.accTypes,
            message: response.msg,
            status: true,
            vendorSource: response.vndSrc,
        };
    }
    return {};
};
export default clientValidateUserIDMapper;
